import { IAccountShippingPreferences } from '../../models/shipping-preferences';

export const LOAD_SHIPPING_PREFERENCES_SUCCESS =
    'LOAD_SHIPPING_PREFERENCES_SUCCESS';

export const SAVE_SHIPPING_PREFERENCES_SUCCESS =
    'SAVE_SHIPPING_PREFERENCES_SUCCESS';

export const loadShippingPreferencesSuccess = (
    payload: IAccountShippingPreferences[]
) => ({
    type: LOAD_SHIPPING_PREFERENCES_SUCCESS,
    payload,
});

export const saveShippingPreferencesSuccess = () => ({
    type: SAVE_SHIPPING_PREFERENCES_SUCCESS,
});
